export function menu_hover()
{
	let link = $('.home-menu__link');

	link.on('mouseover', function(){
		let index = $(this).attr('data-index');
		let background = `.home-background[data-id="${index}"]`;
		let active_bg  = $(background);
		
		active_bg.addClass('active');
	});

	link.on('mouseout', function(){
		$('.home-background.active').removeClass('active');
	});
}

function detect_touch()
{
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

	var mq = function(query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window)) {
		return true;
	}

	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

function detect_ios() {

	var isAppleDevice = navigator.userAgent.match(/(iPod|iPhone|iPad)/) != null;

	//f active class and body has touch devuce
	return isAppleDevice;
}

export function device_sniffer()
{	
	console.log('working');
	
	if ( detect_touch() || $(window).innerWidth() <= 700 )
	{
		$('body').addClass('mobile-device');
	}

	if ( detect_touch() )
	{
		$('body').addClass('touch-device');
	}
}

export function js_mouse()
{

	// set the starting position of the cursor outside of the screen
	let clientX = -100;
	let clientY = -100;
	
	const innerCursor = document.querySelector('.cursor');

	const initCursor = () => {
		// add listener to track the current mouse position
		document.addEventListener('mousemove', e => {
			clientX = e.clientX;
			clientY = e.clientY;
		});
		
		// transform the innerCursor to the current mouse position
		// use requestAnimationFrame() for smooth performance
		const render = () => {
			innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
			
			requestAnimationFrame(render);
		};
		requestAnimationFrame(render);
	};

	if( !$('body').hasClass('mobile-device') || !$('body').hasClass('touch-device') )
	{
		initCursor();
	}
}

export function new_mouse_hover()
{
	const cursorText = $('.cursor__text');
	const innerCursor = document.querySelector('.cursor');
	cursorText.text('');

	const handleMouseEnter = e => {
		
		const navItem = e.currentTarget;

		let linkText  = $(navItem).attr('data-title');
		let direction = $(navItem).attr('data-dir');

		$(innerCursor).addClass('link-hovered');

		if( direction != null )
		{
			$(innerCursor).attr('data-dir', direction);
		}

		if( linkText == null)
		{
			linkText = '';
		}

		let element = $(navItem)[0];

		if( element.classList.contains('link--reverse') )
		{
			$(innerCursor).addClass('reverse-hovered');
		}

		cursorText.text(linkText);
	};

	const handleMouseClick = e => {
		$(innerCursor).removeClass('link-hovered reverse-hovered');

		setTimeout(function(){
			$(innerCursor).addClass('link-hovered');
		}, 450 );
	};
	
	// reset isStuck on mouseLeave
	const handleMouseLeave = () => {
		$(innerCursor).removeClass('link-hovered reverse-hovered');
		$(innerCursor).attr('data-dir', '');
	};

	const initHovers = () => {
		
		// add event listeners to all items
		const linkItems = document.querySelectorAll('.link');

		linkItems.forEach(item => {
			item.addEventListener('mouseenter', handleMouseEnter);
			item.addEventListener('click', handleMouseClick);
			item.addEventListener('mouseleave', handleMouseLeave);
		});
	};

	if( !$('body').hasClass('mobile-device') )
	{
		initHovers();
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/page.js